import { Head } from 'vite-react-ssg'

const SITE = 'https://pelvia.me'
/** Cards are built by scripts/og/cards.mjs at 1200x630, the ratio twitter:card=summary_large_image expects. */
const DEFAULT_IMAGE = '/static/og/default.png'

interface SeoProps {
  /** Full <title> text. */
  title: string
  /** Meta description + og/twitter description. */
  description: string
  /** Route path (e.g. '/endometriosis'); builds the canonical + og:url. */
  path: string
  /** OG/Twitter card, site-relative (e.g. '/static/og/mission.png') or absolute. Defaults to the site card. */
  image?: string
}

/**
 * Per-route document head: title, description, canonical, and Open Graph /
 * Twitter card tags. Rendered into the static HTML at build time (vite-react-ssg
 * / react-helmet) so crawlers and social link-preview bots see real metadata —
 * see PEL-63. Overrides the defaults in index.html.
 */
export default function Seo({ title, description, path, image = DEFAULT_IMAGE }: SeoProps) {
  const url = `${SITE}${path}`
  // Crawlers reject a relative og:image, so absolutize here rather than at every call site.
  const imageUrl = image.startsWith('http') ? image : `${SITE}${image}`
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Pelvia" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Head>
  )
}
